export function practiceTimezone(value) {
    if (typeof value !== "string" || value.length > 64)
        return "UTC";
    try {
        return new Intl.DateTimeFormat("en", { timeZone: value }).resolvedOptions()
            .timeZone;
    }
    catch (_a) {
        return "UTC";
    }
}
const dateFormatters = new Map();
export function practiceDate(now, timezone) {
    let formatter = dateFormatters.get(timezone);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat("en-US", {
            timeZone: timezone,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
        dateFormatters.set(timezone, formatter);
    }
    const parts = formatter.formatToParts(now);
    const part = (name) => parts.find((p) => p.type === name).value;
    return `${part("year")}-${part("month")}-${part("day")}`;
}
export function shiftPracticeDate(date, days) {
    const value = new Date(`${date}T12:00:00Z`);
    value.setUTCDate(value.getUTCDate() + days);
    return value.toISOString().slice(0, 10);
}
export function practiceProgress(dates, today) {
    const days = [...new Set(dates)].filter((date) => date <= today).sort();
    const seen = new Set(days);
    const weekday = new Date(`${today}T12:00:00Z`).getUTCDay();
    const weekStart = shiftPracticeDate(today, -((weekday + 6) % 7));
    let streak = 0;
    let cursor = seen.has(today) ? today : shiftPracticeDate(today, -1);
    while (seen.has(cursor)) {
        streak++;
        cursor = shiftPracticeDate(cursor, -1);
    }
    return {
        today,
        completedToday: seen.has(today),
        streak,
        totalDays: days.length,
        week: Array.from({ length: 7 }, (_, index) => {
            const date = shiftPracticeDate(weekStart, index);
            return {
                date,
                practiced: seen.has(date),
                today: date === today,
                future: date > today,
            };
        }),
        daysThisWeek: days.filter((date) => date >= weekStart).length,
    };
}
/** Playing and learning feed one calendar. Multiple activities never add extra days. */
export function chessStreakProgress(dates, today) {
    const progress = practiceProgress(dates, today);
    const unique = [...new Set(dates)].filter((date) => date <= today).sort();
    let longest = 0;
    let run = 0;
    let previous;
    for (const date of unique) {
        run = previous && shiftPracticeDate(previous, 1) === date ? run + 1 : 1;
        longest = Math.max(longest, run);
        previous = date;
    }
    return Object.assign(Object.assign({}, progress), { activityDates: unique, longestStreak: longest, milestones: [7, 30, 100, 365].map((target) => ({
            target,
            earned: longest >= target,
        })) });
}
//# sourceMappingURL=chessActivityCalendar.js.map